import React, { useState, useContext, useEffect } from "react";
import { StateContext } from "../App";
import Axios from "axios";
import M from "materialize-css";
import "./deposit.css";

function Deposit(props) {
  const { state, dispatch } = useContext(StateContext);
  const [error, setError] = useState("");


  useEffect(() => {

    const notLoadingBtn = document.querySelector(".deposit .not-loading");

    if (error) {
      const error = document.querySelector(".error");
      error.style.display = "block";

      notLoadingBtn.classList.add("disabled")

    } else {
      const error = document.querySelector(".error");
      error.style.display = "none";

      notLoadingBtn.classList.remove("disabled")
    }
  }, [ error ])

  const startPayment = async (e) => {
    e.preventDefault();
    setError("")

    const notLoadingBtn = document.querySelector(".deposit .not-loading");

    notLoadingBtn.textContent = "Processing...";

    // checkAmount();

    setTimeout(() => {

      switch (error) {
        case "Invalid amount confirm the selected plan!":

          notLoadingBtn.textContent = "Start Investment";
          
          break;
        case "":

        // alert();

          const form = document.querySelector("form");
          const amount = form.amount.value;
          const plan = form.planType.value;
          const currencyType = form.currencyType.value;
          const userEmail = state.user ? state.user.email : null;
          const userId = state.user ? state.user._id : null;
      
      
          const options = {
            plan,
            amount,
            currencyType,
            userEmail,
            userId,
          };
      
          if (!error) {

            // alert("push about to happen")
            
            dispatch({ type: "SET_INVOICE", payload: options });

            props.history.push("/dashboard/invoice");
          }

          break;
      }

    }, 2000)

/* 
    if (!error) {
      try {
        const res = await Axios.post("/invest", options);
        res && console.log("This is An Investment payment Response ===", res);
        if (res.data.payment_url) {
            notLoadingBtn.textContent = "Start investment";
            window.location.href = res.data.payment_url;
        } else {
            console.log("Check Your Internet Connection!");
        }
      } catch (err) {
        // Stop The Loader Here!

        console.log("This is An Investment payment ERR! ===", err);
      }
    } else {
    }

 */    
  };


  useEffect(() => {
    var elems = document.querySelectorAll("select");
    var instances = M.FormSelect.init(elems);
  }, []);

  const showError = () => {
    const select = document.querySelector(".custom-select-field")

    if (error) {
      select.style.color = "red"
    }
  }


  const checkAmount = () => {

    setError("");

    const form = document.querySelector("form");
    const amount = form.amount.value;
    const plan = form.planType.value;
    const notLoadingBtn = document.querySelector(".deposit .not-loading");
    
    

    switch (plan) {
      case "Educative Plan 24hrs":
        // console.log("EDUCATIVE PLAN")
        if (amount > 299) {
          // form.amount.value = "";
          setError("Invalid amount confirm your selected plan!");
          notLoadingBtn.textContent = "Start Investment";
        } else if (amount < 70) {
          // form.amount.value = "";
          setError("Invalid amount confirm your selected plan!");
          notLoadingBtn.textContent = "Start Investment";
        }

        break;
      case "Basic Plan 48hrs":
        // console.log("BASIC PLAN")
        if (amount > 999) {
          // form.amount.value = "";
          setError("Invalid amount confirm your selected plan!");
          notLoadingBtn.textContent = "Start Investment";
        } else if (amount < 100) {
          // form.amount.value = "";
          setError("Invalid amount confirm your selected plan!");
          notLoadingBtn.textContent = "Start Investment";
        }

        break;
      case "Reliable Plan 72hrs":
        // console.log("RELIABLE PLAN")
        if (amount > 1999) {
          // form.amount.value = "";
          setError("Invalid amount confirm your selected plan!");
          notLoadingBtn.textContent = "Start Investment";
        } else if (amount < 1000) {
          // form.amount.value = "";
          setError("Invalid amount confirm your selected plan!");
          notLoadingBtn.textContent = "Start Investment";
        }

        break;
      case "Dedicative Plan 5days":
        // console.log("DEDICATIVE PLAN")
        if (amount > 4999) {
          // form.amount.value = "";
          setError("Invalid amount confirm your selected plan!");
          notLoadingBtn.textContent = "Start Investment";
        } else if (amount < 2000) {
          // form.amount.value = "";
          setError("Invalid amount confirm your selected plan!");
          notLoadingBtn.textContent = "Start Investment";
        }

        break;
      case "Fidelity Plan 7days":
        // console.log("FIDELITY PLAN")
        if (amount < 5000) {
          // form.amount.value = "";
          setError("Invalid amount confirm your selected plan!");
          notLoadingBtn.textContent = "Start Investment";
        }

        break;
    }
  };

  return (
    <div className="deposit">
      <h2>start an investment</h2>
      {/* <div className="divider"></div> */}
      <div className="container">
        <form onSubmit={startPayment}>
          <div className="container">
            <div className="row">
            <div className="col s12 m10 l10">
                <input type="text" defaultValue={state.user ? state.user.name : ""} />
            </div>
            <br />
            <br />
            <br />
                <span className="error"> {error} </span>
              <div className="col s12 m10 l10">
                <input
                  type="number"
                  placeholder="enter amount"
                  name="amount"
                  required
                  onChange={checkAmount}
                  className="deposit_amount_input"
                />
              </div>
                {/* Select Plan */}
              <div className="input-field col s12 select-field">
                <label></label>
                <select name="planType" required onChange={ checkAmount } className="browser-default custom-select-field">
                  <option value="" disabled selected>
                    Select Plan
                  </option>

                  <option value="Basic Plan 48hrs">
                    Basic Plan $(100-999) - 48hrs - Profit 10%
                  </option>
                  <option value="Reliable Plan 72hrs">
                   Reliable Plan $(1,000-1,999) - 72hrs - Profit 15%
                  </option>
                  <option value="Dedicative Plan 5days">
                    Dedicative Plan $(2,000-4,999) - 5 days - Profit 20%
                  </option>
                  <option value="Fidelity Plan 7days">
                    Fidelity Plan NO $(5,000-No LIMIT) - 7 days - Profit 50%
                  </option>                 
                </select>
              </div>
              <br />
              {/* Select Currency type */}
              <div className="input-field col s12 select-field">
                <select name="currencyType" required className="browser-default" >
                  {/* <option value="" disabled selected>
                    Select Currency
                  </option> */}
                  {/* <option value="btc">BTC</option>
                <option value="eth">ETH</option>
                <option value="ltc">LTC</option> */}
                  <option selected value="USD">USD</option>x
                </select>
              </div>
            </div>
          </div>
          <div className="container">
            <button className="not-loading">start investment</button>
            <div className="btn-back">
              {/* <button disabled className="loading-btn">
              <div id="loader"></div>
            </button> */}
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}

export default Deposit;
